import PillarPageLayout from "@/components/PillarPageLayout";
export default function GeographieDuVinPage() { return <PillarPageLayout slug="geographie-du-vin" />; }
